export default function polyfills() {
	/* .closest method */
	if (window.Element && !Element.prototype.closest) {
		Element.prototype.closest = function(s) {
			var matches = (this.document || this.ownerDocument).querySelectorAll(s),
				i,
				el = this;
			do {
				i = matches.length;
				// eslint-disable-next-line
                while (--i >= 0 && matches.item(i) !== el) {};
			} while (i < 0 && (el = el.parentElement));
			return el;
		};
	}

	if (!('remove' in Element.prototype)) {
		Element.prototype.remove = function() {
			if (this.parentNode) {
				this.parentNode.removeChild(this);
			}
		};
	}
}



// WEBPACK FOOTER //
// ./scripts/util/polyfills.js